import { mapActions, mapMutations } from 'vuex';

import { email, required } from 'vuelidate/lib/validators';
import validation from '@/mixins/validation';

export default {
  name: 'MessengerModal',
  components: {},
  props: {},
  data() {
    return {
      payload: {
        name: '',
        last_name: '',
        phone: '',
        email: ''
      },
      isLoading: false,
      validationErrors: {}
    };
  },
  mixins: [validation],
  validations: {
    payload: {
      name: {
        required
      },
      last_name: {
        required
      },
      phone: {
        required
      },
      email: {
        required,
        email
      }
    }
  },
  created() {
    document.getElementById('html').classList.add('hide');
  },
  mounted() {},
  watch: {},
  computed: {
    phoneErrors() {
      return this.computeErrors('payload', 'phone', {
        required: 'validationRequired'
      });
    },
    emailErrors() {
      return this.computeErrors('payload', 'email', {
        required: 'validationRequired',
        email: 'validationEmail'
      });
    },
    nameErrors() {
      return this.computeErrors('payload', 'name', {
        required: 'validationRequired'
      });
    },
    lastNameErrors() {
      return this.computeErrors('payload', 'last_name', {
        required: 'validationRequired'
      });
    }
  },

  methods: {
    ...mapActions({
      sendMessengerForm: 'setting/SEND_MESSENGER_FORM'
    }),
    ...mapMutations({
      modalClose: 'app/MODAL_CLOSE'
    }),
    async onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isLoading = true;
        this.sendMessengerForm(this.payload)
          .then(() => {
            this.payload = {
              name: '',
              last_name: '',
              phone: '',
              email: ''
            };
            this.$toasted.success(this.$t('modal.messengerForm.textSuccess'));
          })
          .catch(() => {
            this.$toasted.error(this.$t('modal.messengerForm.textError'));
          })
          .finally(() => {
            this.isLoading = false;
            this.modalClose('messengerModal');
          });
      }
    }
  }
};
